import Axios from 'axios'
import { ChatHistory, MentorAIRequest, MentorAIResponse } from '../types/mentorTypes'

export const ApiAI = Axios.create({
    baseURL: process.env.REACT_APP_AI_API,
})

/**
 * Send a request to the Mentor AI API
 * @param messageToMentorAI The request payload with question and context
 * @returns MentorAIResponse with answer and escalate properties
 */
export const askMentorAI = async (messageToMentorAI: MentorAIRequest): Promise<MentorAIResponse> => {
    const response = await ApiAI.post('/mentors/content-query', messageToMentorAI);    
    // Check if we have a valid response
    if (!response.data) {
        throw new Error('Invalid response from Mentor AI API');
    }
    
    // Handle different API response structures
    let result: MentorAIResponse;
    
    if (response.data.data) {
        // If API returns nested data property
        result = response.data.data;
    } else if (response.data.answer !== undefined) {
        // If the answer is directly in the response
        result = response.data;
    } else {
        // If we can't determine the structure, throw an error
        console.error('Unexpected API response format:', response.data);
        throw new Error('Unexpected response format from Mentor AI API');
    }
    
    // Ensure the result has the correct structure
    if (typeof result.answer !== 'string') {
        throw new Error('API response missing answer field');
    }
    
    // If escalate is missing, default to false
    if (result.escalate === undefined) {
        result.escalate = false;
    }
    
    return result;
}

/**
 * Fetch chat history by chat ID
 * @param chatId The unique identifier for the chat
 * @returns The chat history data
 */
export const getChatById = async (chatId: string) => ApiAI.get<ChatHistory>(`/chats?chatId=${encodeURIComponent(chatId)}`).then(({data}) => data)


